export const FAILED = 'FAILED';
export const OUT_OF_SYNC = 'OUT_OF_SYNC';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const UNINITIALIZED = 'UNINITIALIZED';